var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconOrganizations = function SvgIconOrganizations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-no-fill": "true",
    d: "M11 20h10V10a2 2 0 0 0-2-2h-4m-4 8h.01M17 16h.01M7 16h.01M11 12h.01M17 12h.01M7 12h.01M11 8h.01M7 8h.01M15 20V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14h12Z"
  })));
};
export { SvgIconOrganizations as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiDQogICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogICAgPHBhdGggZGF0YS1uby1maWxsPSJ0cnVlIg0KICAgICAgICAgIGQ9Ik0xMSAyMEgyMVYxMEMyMSA4Ljg5NTQzIDIwLjEwNDYgOCAxOSA4SDE1TTExIDE2SDExLjAxTTE3IDE2SDE3LjAxTTcgMTZINy4wMU0xMSAxMkgxMS4wMU0xNyAxMkgxNy4wMU03IDEySDcuMDFNMTEgOEgxMS4wMU03IDhINy4wMU0xNSAyMFY2QzE1IDQuODk1NDMgMTQuMTA0NiA0IDEzIDRINUMzLjg5NTQzIDQgMyA0Ljg5NTQzIDMgNlYyMEgxNVoiDQogICAgLz4NCjwvc3ZnPg==";